import { compact } from 'es-toolkit';
export const getUserFullName = (user) => {
    if (!user)
        return undefined;
    return compact([user.firstName, user.lastName])
        .map(name => name.trim())
        .join(' ');
};
//# sourceMappingURL=user.js.map